export const DBAAS_URL = '/dbaas';
